import { formatBytes } from "@/features/patient-view/components/documents/editor/utils";
import classNames from "classnames";
import { useEffect, useState } from "react";

interface FileItemProps {
    file: File;
    loading: boolean;
    onRemove: (file: any) => void;
}

const FileItem: React.FC<FileItemProps> = ({ file, onRemove, loading }) => {
    const [progress, setProgressState] = useState(0);

    // update the progress bar every second if the file is still uploading
    useEffect(() => {
        if (loading) {
            const interval = setInterval(() => {
                setProgressState((prevProgress) => {
                    const newProgress = Math.min(prevProgress + 10, 100);
                    return newProgress;
                });
            }, 500);

            return () => clearInterval(interval);
        } else {
            setProgressState(100);
        }
    }, [loading]);

    return (
        <div className="flex flex-row items-center justify-between w-full rounded-md bg-gray-50 p-4 border border-gray-200">
            <div className="w-full flex flex-col gap-2">
                <span className="text-gray-900 text-sm font-medium">{file?.name}</span>
                <div className="flex flex-row items-center gap-2">
                    <span className="text-gray-600 text-xs">{formatBytes(file?.size)}</span>
                    {loading && (
                        <progress
                            className="w-full progress progress-bar max-w-[200px]"
                            value={progress}
                            max="100"
                        ></progress>
                    )}
                </div>
            </div>
            <button
                disabled={loading}
                onClick={() => onRemove(file)}
                className={classNames(
                    "px-2 py-1 font-semibold text-xs rounded-md  bg-white ring-1 ring-gray-200 text-gray-700",
                    "hover:bg-gray-100",
                    loading ? "cursor-not-allowed opacity-50" : "cursor-pointer",
                )}
            >
                Delete
            </button>
        </div>
    );
};

export default FileItem;
